




import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },
  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },
});
